/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/drawer-cart.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/drawer-cart.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
  /* 2026-09-28 cart-fix-m visual-site C119 (Claude). A PDP add that Shopify refuses or trims (422, e.g. "Only 2 items were
     added to your cart due to availability.") wrote its sentence into the product form, which sits UNDER the open drawer,
     so the shopper saw the drawer fill with fewer units than they asked for and no reason (on phones the drawer is full
     screen, so the sentence was never visible at all). The same sentence now also shows at the top of the open drawer
     for 10 seconds, in a role=alert notice, until the drawer closes or the shopper presses Add again. Nothing else changes.
     Rollback: delete this script block and the "C119 add notice" rule in assets/widget-minicart.css. */
  (function () {
    if (window.__aoamAddNotice) return; window.__aoamAddNotice = true;
    var note = null, timer = null, keep = null;
    function drop() {
      clearTimeout(timer); clearInterval(keep);
      if (note && note.parentNode) note.parentNode.removeChild(note);
      note = null; rowKey = null;
    }
    function spot() {
      var d = document.getElementById('header_minicart');
      if (!d) return null;
      var sc = d.querySelector('.cart__drawer-form .cart__scrollable');
      if (sc && sc.getBoundingClientRect().height > 0) return { parent: sc.parentNode, before: sc };
      var inner = d.querySelector('.site-header__drawer-inner') || d;
      return { parent: inner, before: inner.children[1] || null };
    }
    /* 2026-09-28 cart-fix-l visual-site-low C121 C125 (Claude): the same notice is now callable as
       window.aoamDrawerNotice(msg, {key, ms, silent}). With a line key it sits directly under that row's card
       (re-attached when the rows re-render); silent skips role=alert where the cart's hidden status region already
       reads the sentence out. The PDP path below is unchanged. Rollback: restore the pre-2026-09-28.6 block. */
    var rowKey = null;
    function rowSpot() {
      var d = document.getElementById('header_minicart'); if (!d) return null;
      var rows = d.querySelectorAll('.cart__scrollable .cart__item[data-key]');
      for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-key') === rowKey && rows[i].getBoundingClientRect().height > 0) return { parent: rows[i].parentNode, before: rows[i].nextSibling };
      return null;
    }
    function attach() {
      if (!note || note.isConnected) return;
      var s = rowKey ? rowSpot() : spot(); if (!s) return;
      s.parent.insertBefore(note, s.before && s.before.parentNode === s.parent ? s.before : null);
    }
    function show(msg, opts) {
      if (!msg || typeof msg !== 'string') return false;
      if (!document.documentElement.classList.contains('js-drawer-open')) return false;
      opts = opts || {};
      drop();
      rowKey = opts.key ? String(opts.key) : null;
      note = document.createElement('p');
      note.className = rowKey ? 'aoam-add-notice aoam-add-notice--row' : 'aoam-add-notice';
      if (!opts.silent) note.setAttribute('role', 'alert');
      note.textContent = msg;
      attach();
      keep = setInterval(function () {
        if (!document.documentElement.classList.contains('js-drawer-open')) { drop(); return; }
        attach();
      }, 300);
      timer = setTimeout(drop, opts.ms || 10000);
      return true;
    }
    window.aoamDrawerNotice = show;
    document.addEventListener('ajaxProduct:error', function (e) {
      var msg = e && e.detail && e.detail.errorMessage;
      if (!msg || typeof msg !== 'string') return;
      setTimeout(function () { show(msg); }, 150);
    });
    // a NEW add press clears it (not ajaxProduct:added: the healers fire that when the trimmed units land, which would wipe the notice at once)
    document.addEventListener('click', function (e) { var b = e.target && e.target.closest && e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"]'); if (b && !b.closest('#header_minicart')) drop(); }, true);
  })();
  

  /* 2026-11-03 W1B (Claude, cart audit 2026-11-02, Joel: "lets ship all"; mockups D and E).
     1. D (F-001): under 760px tall the trust row (30-day returns / reviews / Oregon) leaves the docked footer and sits
        at the end of the scroller, under the rail, so the footer gives its height back to the product rows. It moves
        back when the screen grows past 760px (a phone rotated, a window resized). Styled by the W1B block at the end
        of assets/widget-minicart.css.
     2. E (F-006): when the cart drawer closes, focus goes back to whatever opened it (the header cart button, a
        "View cart" link or an Add to cart button), so keyboard and screen reader users land where they were. theme.js
        Drawer.close() only blurs.
     Rollback: delete this block (and the W1B block in widget-minicart.css). */
  (function () {
    if (window.__aoamW1b) return; window.__aoamW1b = '2026-11-03.w1b';
    var mq = window.matchMedia ? window.matchMedia('(max-height: 760px)') : null;
    var home = null;
    function parts() {
      var d = document.getElementById('header_minicart'); if (!d) return null;
      var form = d.querySelector('.cart__drawer-form'); if (!form) return null;
      var sc = form.querySelector('.cart__scrollable'), tr = form.querySelector('.aoam-trust-row');
      return sc && tr ? { sc: sc, tr: tr } : null;
    }
    function place() {
      var p = parts(); if (!p || !mq) return;
      if (mq.matches) {
        if (p.tr.parentNode !== p.sc) { home = { parent: p.tr.parentNode, next: p.tr.nextSibling }; p.sc.appendChild(p.tr); }
        else if (p.sc.lastElementChild !== p.tr) p.sc.appendChild(p.tr);
      } else if (p.tr.parentNode === p.sc && home && home.parent.isConnected) {
        home.parent.insertBefore(p.tr, home.next && home.next.parentNode === home.parent ? home.next : null);
      }
    }
    /* landscape: TOTAL sticks just above the checkout block, whose height varies (duties line outside the US) */
    function cow() {
      var d = document.getElementById('header_minicart'), w = d && d.querySelector('.cart__drawer-form .cart__checkout-wrapper');
      if (w) d.style.setProperty('--w1b-cow', w.offsetHeight + 'px');
    }
    function placeAll() { place(); cow(); }
    placeAll();
    if (window.ResizeObserver) { var cw = document.querySelector('#header_minicart .cart__drawer-form .cart__checkout-wrapper'); if (cw) new ResizeObserver(cow).observe(cw); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeAll);
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', placeAll); else if (mq.addListener) mq.addListener(placeAll); }
    document.addEventListener('drawerOpen', function () { setTimeout(placeAll, 0); });

    var opener = null;
    var OPENERS = '[data-header-cart-trigger], .js-drawer-open-right, .view-cart-btn, [name="add"], form[action*="/cart/add"] [type="submit"]';
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest(OPENERS);
      if (t && !t.closest('#header_minicart')) opener = t;
    }, true);
    var d = document.getElementById('header_minicart');
    if (d && window.MutationObserver) {
      var was = d.classList.contains('js-drawer-open');
      new MutationObserver(function () {
        var now = d.classList.contains('js-drawer-open');
        if (was && !now) {
          var o = opener, a = document.activeElement; opener = null;
          if (o && o.isConnected && o.getClientRects().length && (!a || a === document.body || d.contains(a))) {
            try { o.focus({ preventScroll: true }); } catch (err) {}
          }
        }
        was = now;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  })();
